module.exports = __webpack_public_path__ + "static/media/sell_interview_3.ef9af4f9.jpg";